<template>
  <div v-if="venueCampaign">
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Venue Campaign</h2>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">Master campaign title</span>
          <vs-row
            ><b>{{ venueCampaign.title }}</b></vs-row
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Fillout deadline</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">Deadline to be approved at latest</span>
          <vs-row
            ><b>{{ moment(venueCampaign.approvedByDate).format("LL") }}</b></vs-row
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Send date</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">Scheduled to be sent, if approved, at</span>
          <vs-row
            ><b>{{ moment(venueCampaign.sendByDate).format("LL") }}</b></vs-row
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Status</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-row>
            <vs-chip :color="statusObject(venueCampaign.status).color">
              <b>{{ statusObject(venueCampaign.status).text }}</b>
            </vs-chip>
          </vs-row>
          <vs-row v-if="venueCampaign.status == 'Rejected'">
            <vs-row>
              <vs-row>
                Rejected by {{ venueCampaign.rejectedAction.userDisplayName }} <br />
                at {{ moment(venueCampaign.rejectedAction.timestamp).format("DD-MM-yyyy HH:mm") }}
              </vs-row>
              <vs-row>
                <span class="mt-2"><b>Reason: </b> {{ venueCampaign.rejectedComment }}</span>
              </vs-row>
            </vs-row>
          </vs-row>
          <vs-row v-if="venueCampaign.status == 'Approved'">
            Approved at {{ moment(venueCampaign.approvedAction.timestamp).format("DD-MM-yyyy HH:mm") }} <br />
            by {{ venueCampaign.approvedAction.userDisplayName }}
          </vs-row>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row vs-justify="space-between" class="flex flex-wrap items-center" style="margin-top: 32px">
        <div></div>
        <vs-button v-if="isEditable" id="submit-button" @click="$emit('onSubmit')" class="mt-2 py-6"
          >{{ venueCampaign.status == "Rejected" ? "Res" : "S" }}ubmit for approval</vs-button
        >
        <vs-button
          v-if="isEditable"
          color="danger"
          id="reset-button"
          @click="$emit('onReset')"
          class="mt-2 py-6"
          >Reset entire template</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import { DatePicker } from "v-calendar";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  props: ["venueCampaign", "isEditable"],
  mixins: [campaignMixin],
  components: {
    flatPickr,
    DatePicker,
  },
  data() {
    return {
      moment,
    };
  },
};
</script>

<style lang="scss">
</style>